export enum HackedProcedures {
  //if you wondered, it's medstrat converted to decimal and added together :)
  ImageViewer = -868
}